import {Entity} from '@s-ui/domain'

export default class VehicleEntity extends Entity {
  /**
   * @param {Object} params
   * @param {String} params.id
   * @param {String} params.carPlate
   * @param {String} params.make
   * @param {String} params.makeId
   * @param {String} params.model
   * @param {String} params.modelId
   * @param {String} params.bodyType
   * @param {String} params.bodyTypeId
   * @param {String} params.version
   * @param {String} params.versionId
   * @param {String} params.url
   * @param {Number} params.searchUrl
   * @param {String} params.fuelType
   * @param {String} params.fuelTypeId
   * @param {String} params.plateRegistrationDate
   * @param {String} params.plateRegistrationYear
   * @param {Number} params.price
   * @param {Number} params.hp
   * @param {Number} params.year
   * @param {Number} params.doors
   * @param {Number} params.acceleration
   * @param {String} params.transmissionType
   * @param {String} params.transmissionTypeId
   * @param {Number} params.luggageCapacity
   * @param {String} params.imageUrlPath
   * @param {Number} params.height
   * @param {Number} params.length
   * @param {Number} params.width
   * @param {Number} params.weight
   * */

  get value() {
    return {
      id: this._id,
      carPlate: this._carPlate,
      make: this._make,
      makeId: this._makeId,
      model: this._model,
      modelId: this._modelId,
      bodyType: this._bodyType,
      bodyTypeId: this._bodyTypeId,
      version: this._version,
      versionId: this._versionId,
      url: this._url,
      searchUrl: this._searchUrl,
      fuelType: this._fuelType,
      fuelTypeId: this._fuelTypeId,
      plateRegistrationDate: this._plateRegistrationDate,
      plateRegistrationYear: this._plateRegistrationYear,
      price: this._price,
      hp: this._hp,
      year: this._year,
      doors: this._doors,
      acceleration: this._acceleration,
      transmissionType: this._transmissionType,
      transmissionTypeId: this._transmissionTypeId,
      luggageCapacity: this._luggageCapacity,
      imageUrlPath: this._imageUrlPath,
      interiorDimensions: this._interiorDimensions,
      height: this._height,
      length: this._length,
      width: this._width,
      weight: this._weight
    }
  }

  getId() {
    return this._id
  }
}
